export enum ActionType {
	DATA_LOADED = "DATA_LOADED",
	LOG_IN = "LOG_IN",
	LOG_OUT = "LOG_OUT",
	SET_USER_TOKEN = "SET_USER_TOKEN",
	SET_USER_PRESET_AREAS = "SET_USER_PRESET_AREAS",
	SET_AREA = "SET_AREA",
	SET_ANNOUNCEMENTS = "SET_ANNOUNCEMENTS",
	SET_ARCHIVE_TERMS = "SET_ARCHIVE_TERMS"
}
